// DOM-dependent utilities — these functions require a browser environment.

// Decode HTML entities (e.g., &quot;, &amp;, &lt;, &gt;, &#039;)
// Uses a textarea element internally; safe because textarea.value strips all tags.
export const decodeHtmlEntities = (text: string): string => {
  if (!text || typeof text !== "string") return text;
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
};
